<template>
  <div id="base-banners">
    <v-layout :key="banner.bannerId" align-center justify-center row v-for="banner in banners" wrap>
      <v-flex xs12>
        <a
          :href="banner.bannerLink"
          :rel="banner.bannerName"
          :target="banner.bannerLink.slice(0, 4) == 'http' ? '_blank' : '_parent'"
        >
          <!-- :aspect-ratio="4/4" -->
          <v-img
            :alt="banner.bannerName"
            :lazy-src="require('@/assets/logo_footer.png')"
            :src="banner.bannerPicture ? banner.bannerPicture : require('@/assets/logo_footer.png')"
            contain
          >
            <template v-slot:placeholder>
              <v-layout align-center fill-height justify-center ma-0>
                <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </a>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'base-banners',
  data() {
    return {}
  },
  props: {
    sitesId: {
      type: String,
      default: 'SITE0000001'
    },
    pageId: {
      type: String,
      default: ''
    },
    bannerPositionId: {
      type: String,
      default: ''
    }
  },
  computed: {
    banners() {
      return this.$store.getters['Banners/getAll'].filter(
        item =>
          item.sitesId == this.sitesId &&
          item.pageId == this.pageId &&
          item.bannerPositionId == this.bannerPositionId
      )
    }
  },
  async created() {
    await this.$store.dispatch('Banners/fetch')
  }
}
</script>

<style lang="scss" scoped></style>
